var Handlebars = require('/var/lib/jenkins/jobs/wunderman_resolution/workspace/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"content-wrapper site-block\">\n"
    + ((stack1 = container.invokePartial(partials.form,(depth0 != null ? depth0.form : depth0),{"name":"form","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/test.hbs
// module id = 32
// module chunks = 0